import { render, staticRenderFns } from "./FilterRecord.vue?vue&type=template&id=c88d2caa"
import script from "./FilterRecord.vue?vue&type=script&lang=js"
export * from "./FilterRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports